import { TypedUseSelectorHook, useSelector, useDispatch } from "react-redux"
import { RootState, AppDispatch } from "./store"

export const useAppSelector : TypedUseSelectorHook<RootState> = useSelector
// Use AppDispatch instead of useDispatch for type-casting of the Root state
export const useAppDispatch = () => useDispatch<AppDispatch>()  